module.exports = __webpack_public_path__ + "img/ic_star.a3a2da47.svg";